import PropTypes from "prop-types";
import React from "react";
import WeatherSunIcon from "../../../../shared/Icons/WeatherSunIcon";
import TrendUpIcon from "../../../../shared/Icons/TrendUpIcon";
import MapPinIcon from "../../../../shared/Icons/MapPinIcon";

const DateFactorsCard = ({ hold, weatherPending }) => {
  const hasLocal = hold.localEvents && hold.localEvents.length > 0;
  return (
    <div className="d2-card hd-detail-card">
      <div className="d2-card-header"><h3 className="d2-card-title">Date factors</h3></div>
      <div className="hd-factors">
        {(hold.weather || weatherPending) && (
          <div className="hd-factor">
            <span className="hd-factor-icon"><WeatherSunIcon /></span>
            <div className="hd-factor-body">
              {hold.weather ? (
                <>
                  <div className="hd-factor-label">{hold.weather.historical ? "Weather (typical)" : "Weather (forecast)"}</div>
                  <div className="hd-factor-sub">
                    {`High ${hold.weather.high}°, ${hold.weather.condition}${hold.weather.precipPct != null ? `, ${hold.weather.precipPct}% precip.` : ""}`}
                    {hold.weather.historical && <span className="hd-muted"> · avg. of past years</span>}
                  </div>
                </>
              ) : (
                <>
                  <div className="hd-factor-label">Weather</div>
                  <div className="hd-factor-sub hd-muted">Checking the forecast…</div>
                </>
              )}
            </div>
          </div>
        )}
        {hold.seasonality && (
          <div className="hd-factor">
            <span className="hd-factor-icon"><TrendUpIcon /></span>
            <div className="hd-factor-body">
              <div className="hd-factor-label">Seasonality</div>
              <div className="hd-factor-sub">{hold.seasonality}</div>
            </div>
          </div>
        )}
        <div className="hd-factor">
          <span className="hd-factor-icon"><MapPinIcon /></span>
          <div className="hd-factor-body">
            <div className="hd-factor-label">Local events</div>
            {hasLocal ? (
              <ul className="hd-local-events">
                {hold.localEvents.map((e) => (
                  <li key={e.id} className="hd-factor-sub">{e.name}{e.venue ? ` · ${e.venue}` : ""}</li>
                ))}
              </ul>
            ) : (
              <div className="hd-factor-sub hd-muted">No notable local events.</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

DateFactorsCard.propTypes = { hold: PropTypes.object.isRequired, weatherPending: PropTypes.bool };
export default DateFactorsCard;
